import React from "react";
import Container from "../Container";
import { StaticImage } from "gatsby-plugin-image";
import RichtextRenderer from "../RichtextRenderer";
import Button from "../basic/Button";
import { downloadFile } from "../../utils/downloadFile";

const PaddedBlockWithBg = ({
  backgroundImage,
  title,
  text,
  buttonLabel,
  file,
  leftBlockBgColor = "rgb(255,255,255,.7)",
}) => {
  return (
    <Container>
      <div className="flex flex-col md:flex-row pt-24px md:pt-0 bg-clip-content">
        <div className="w-full relative">
          <div
            style={{
              backgroundImage: `url(${backgroundImage.gatsbyImageData.images.fallback.src})`,
            }}
            className="absolute w-full h-full inset-0 bg-[length:100%_105%] md:bg-cover bg-center bg-no-repeat rounded-t-8px md:rounded-t-none md:!rounded-l-8px"
          />
          <div
            className="h-full flex flex-col justify-center gap-16px w-full p-24px md:py-64px md:px-32px relative z-10 rounded-t-8px md:rounded-t-none md:!rounded-l-8px"
            style={{ backgroundColor: leftBlockBgColor }}
          >
            <StaticImage
              alt="G Mining Logo"
              src={"../../assets/g_mining_logo.svg"}
              quality={100}
              objectFit="cover"
              className="h-50px w-145px -ml-4px"
            />
            <h2 className="break-words capitalize text-nav-green !m-0 font-[Montserrat]">{title}</h2>
          </div>
        </div>
        <div
          className="bg-gray-blue bg-opacity-50 w-full p-32px md:py-64px flex flex-col
         items-start justify-start gap-24px rounded-b-8px md:rounded-b-none md:!rounded-r-8px"
        >
          <RichtextRenderer data={text} config={{ p: "leading-6 text-18px" }} />
          <Button
            onClick={() => downloadFile({ url: file, fileName: title })}
            variant="beige"
            px="px-32px"
            className="md:!mt-0"
            buttonClassName="!py-0"
            arrow
            arrowRotated
            arrowClassName="!h-fit"
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default PaddedBlockWithBg;
